export default __webpack_public_path__ + "static/media/Soulgrist.3e923f18.jpg";